import { render, staticRenderFns } from "./QualityControlGameRow.vue?vue&type=template&id=e395617c&scoped=true"
import script from "./QualityControlGameRow.vue?vue&type=script&lang=js"
export * from "./QualityControlGameRow.vue?vue&type=script&lang=js"
import style0 from "./QualityControlGameRow.vue?vue&type=style&index=0&id=e395617c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e395617c",
  null
  
)

export default component.exports